import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeletonHandoffDirective } from '../../../directives/skeleton-handoff.directive';

/** Shape of a placeholder tile in the content grid. */
interface SkeletonTile {
  spotlight: boolean;
  lines: string[];
}

/**
 * Loading placeholder mirroring the layout of `AtlasLandingpageComponent`
 * (sidebar with logo, headline, actions and footer plus the tile grid), so
 * the switch to the loaded landing page doesn't cause a layout jump.
 */
@Component({
  selector: 'app-atlas-landingpage-skeleton',
  standalone: true,
  hostDirectives: [SkeletonHandoffDirective],
  imports: [NgClass, SkeletonModule],
  templateUrl: './atlas-landingpage-skeleton.component.html',
  styleUrl: './atlas-landingpage-skeleton.component.scss',
})
export class AtlasLandingpageSkeletonComponent {
  readonly actions = [0, 1];

  readonly tiles: SkeletonTile[] = [
    { spotlight: true, lines: ['80%', '65%'] },
    { spotlight: false, lines: ['90%', '70%', '50%'] },
    { spotlight: false, lines: ['85%', '60%'] },
    { spotlight: false, lines: ['90%', '75%', '40%'] },
    { spotlight: false, lines: ['70%', '55%'] },
    { spotlight: false, lines: ['85%', '65%'] },
    { spotlight: true, lines: ['75%', '60%', '45%'] },
  ];
}
